import { ComponentInstall } from "../../utils";
import NumberInput from "./src";

export default ComponentInstall(NumberInput);
